"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AddMediaActionButton = require("./AddMediaActionButton.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AddMediaActionButton = function AddMediaActionButton(_ref) {
  var disabled = _ref.disabled,
    mediaSources = _ref.mediaSources,
    onMediaActionSelected = _ref.onMediaActionSelected;
  var _useState = (0, _react.useState)(-1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selectedIndex = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0, _react.useState)('new content'),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    selectedText = _useState4[0],
    setSelectedText = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    dropdownOpen = _useState6[0],
    setOpen = _useState6[1];
  var toggle = function toggle() {
    return setOpen(!dropdownOpen);
  };
  var onSelected = function onSelected(index, value) {
    if (value && value.type) {
      setSelected(index);
      setSelectedText(value.title);
    } else {
      setSelected(-1);
      setSelectedText('new media');
    }
    onMediaActionSelected(value);
  };
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.ButtonDropdown, {
    isOpen: dropdownOpen,
    toggle: toggle
  }, /*#__PURE__*/_react["default"].createElement(_AddMediaActionButton.StyledButton, {
    disabled: disabled,
    id: "caret",
    color: "primary",
    "data-testid": "add-selected-media"
  }, "Add as ", selectedText), /*#__PURE__*/_react["default"].createElement(_reactstrap.DropdownToggle, {
    disabled: disabled,
    split: true,
    color: "primary",
    "data-testid": "media-action-toggle"
  }), /*#__PURE__*/_react["default"].createElement(_AddMediaActionButton.StyledDropdownMenu, {
    flip: false
  }, /*#__PURE__*/_react["default"].createElement(_AddMediaActionButton.StyledDropdownItem, {
    onClick: function onClick() {
      return onSelected(-1, null);
    },
    selected: selectedIndex === -1
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
    defaultChecked: selectedIndex === -1,
    type: "radio",
    name: "media"
  }), /*#__PURE__*/_react["default"].createElement("div", null, "Create new content")), mediaSources.map(function (media, index) {
    return /*#__PURE__*/_react["default"].createElement(_AddMediaActionButton.StyledDropdownItem, {
      selected: selectedIndex === index,
      key: index,
      onClick: function onClick() {
        return onSelected(index, media);
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Input, {
      defaultChecked: selectedIndex === index,
      type: "radio",
      name: "media"
    }), /*#__PURE__*/_react["default"].createElement("div", null, media.title));
  })));
};
AddMediaActionButton.defaultProps = {
  disabled: true,
  mediaSources: []
};
AddMediaActionButton.propTypes = {
  disabled: _propTypes["default"].bool,
  mediaSources: _propTypes["default"].array.isRequired,
  onMediaActionSelected: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = AddMediaActionButton;